// @ts-check

const buildCellLookup = (lineItems, lookup) => {
  for (const li of lineItems) {
    for (const c of li.cells) {
      // for performance, we don't want to create a new object
      // eslint-disable-next-line no-param-reassign
      lookup[c.id] = c;
    }
  }
  return lookup;
};

export default buildCellLookup;
